import { render } from "./SingleStockCorrectionItemDetails.vue?vue&type=template&id=6b9a6576"
import script from "./SingleStockCorrectionItemDetails.vue?vue&type=script&lang=js"
export * from "./SingleStockCorrectionItemDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__